import LockIcon from '@/shared/assets/lock-icon.svg?react';
import { HIDDEN_BALANCES_FULL_TEXT } from '@/shared/config';
import { cn } from '@/shared/utils';

type Props = {
  isBalancesHidden: boolean;
  text: string;
  suffix?: string;
  className?: string;
};

const WalletsAssetReserved = ({
  isBalancesHidden,
  text,
  suffix,
  className,
}: Props) => (
  <span
    className={cn(
      'flex items-center gap-[0.4rem] p5 text-secondary',
      className
    )}>
    <LockIcon className="size-[1.2rem]" />
    {isBalancesHidden ? HIDDEN_BALANCES_FULL_TEXT : text}
    {suffix ? ` ${suffix}` : ''}
  </span>
);

export { WalletsAssetReserved };
